import storageVisualization from '../../components/storageVisualization/storageVisualization'
import transportationVisualization from '../../components/transportationVisualization/transportationVisualization'
import independentlySoftware from '../../components/independentlySoftware/independentlySoftware'
import independentlySoftware1 from '../../components/independentlySoftware1/independentlySoftware1'
import independentlySoftware2 from '../../components/independentlySoftware2/independentlySoftware2'
import independentlySoftware3 from '../../components/independentlySoftware3/independentlySoftware3'
import independentlySoftware4 from '../../components/independentlySoftware4/independentlySoftware4'
import independentlySoftware5 from '../../components/independentlySoftware5/independentlySoftware5'

export default {
    components: {
      storageVisualization,
      transportationVisualization,
      independentlySoftware,
      independentlySoftware1,
      independentlySoftware2,
      independentlySoftware3,
      independentlySoftware4,
      independentlySoftware5,
    },
    created() {
      this.lang = localStorage.getItem('lang')
      var route = this.$route.path
      if(route === '/technology/storageVisualization') {
        this.currentMenu = "/technology/storageVisualization"
      } else if(route === '/technology/transportationVisualization') {
        this.currentMenu = "/technology/transportationVisualization"
      } else if (route === '/technology/independentlySoftware') {
        this.currentMenu = '/technology/independentlySoftware'
      } else if (route === '/technology/clientInterface') {
        this.currentMenu = '/technology/clientInterface'
      } 
    },
    data() {
      return {
        lang: 'zh',
        // 滚动条高点
        scrollTopTemp : 0,
        //当前选中菜单
        currentMenu: '',
      };
    },
    watch:{
      //监听路由变化
      $route(to,from){
          console.log(to.path);//到哪去
          var route = to.path
          var index = this.$route.query.index || ''
          if(route === '/technology/independentlySoftware') {
            // if(index){
            //   this.currentMenu = index
            // }else{
            //   this.currentMenu = '/technology/independentlySoftware'
            // }
            this.currentMenu = '/technology/independentlySoftware'
          } else if (route === '/technology/storageVisualization') {
            this.currentMenu = '/technology/storageVisualization'
          } else if (route === '/technology/transportationVisualization') {
            this.currentMenu = '/technology/transportationVisualization'
          } else if (route === '/technology/clientInterface') {
            this.currentMenu = '/technology/clientInterface'
          }
      }
    },
    methods: {
      selectFatherMenu(value) {
        var route = this.$route.path
        if(value !== route){
          this.$router.push(value)
        } else {
          this.currentMenu = value
        }
      },
      selectMenu(page){
        var route = this.$route.path
        this.currentMenu = page
        if(page == '/technology/storageVisualization' && route != '/technology/storageVisualization') {
          this.$router.push({path:'/technology/storageVisualization'})
        } else if (page == '/technology/transportationVisualization' && route != '/technology/transportationVisualization') {
          this.$router.push({path:'/technology/transportationVisualization'})
        } else if (page ==  '/technology/independentlySoftware' && route != '/technology/independentlySoftware') {
          // this.$router.push({path:'/technology/independentlySoftware',query:{index: this.currentMenu}})
          this.$router.push({path:'/technology/independentlySoftware'})
        } else if (page ==  '/technology/clientInterface' && route != '/technology/clientInterface') {
          this.$router.push({path:'/technology/clientInterface'})
        }
      },
      goToDetail(path){
        this.currentMenu = path
      }
    }

}


// WEBPACK FOOTER //
// ./src/pages/technology/technology.vue.js